import { ELITE_MODELS, ICameraInfo } from '@thingsw/pitta-modules';
import { useMemo } from 'react';

const useEliteModel = (camera: ICameraInfo | undefined) => {
  const isEliteModel = useMemo(() => {
    if (!camera) return false;

    return ELITE_MODELS.includes(camera.model);
  }, [camera]);

  const isEliteGoldModel = useMemo(() => {
    if (!camera) return false;

    return camera.model === 'ELITE + GOLD';
  }, [camera]);

  return {
    isEliteModel,
    isEliteGoldModel,
  };
};

export default useEliteModel;
